<template>
    <div class="my-1 p-1 relative xl:w-1/6 sm:w-1/2 w-full">
        <v-popover placement="auto" class="ml-2 absolute inset-y-0 right-0">
            <button class="tooltip-target bg-white"><i class="fa fa-question-circle text-grey-dark"></i></button>

            <template slot="popover" class="shadow-lg">
                <ul>
                    <li v-for="description in get_role_descriptions" class="my-1">
                        <i class="fa fa-check text-brand"></i> {{description}}
                    </li>
                </ul>
            </template>
        </v-popover>
        <a href="#" @click.prevent="selectRole()"
            class="flex border rounded group hover:border-brand hover:rounded-l hover:shadow-lg no-underline"
            :class="{
                'border-brand rounded-l shadow-lg text-brand': selectedRole.id == role.id,
            }">
            <div class="inline-flex p-2 rounded-l group-hover:bg-white group-hover:text-brand group-hover:border-r group-hover:border-brand"
                :class="{
                    'text-brand bg-white border-r border-brand': selectedRole.id == role.id, 
                    'bg-brand text-white': selectedRole == '', 
                    'bg-grey text-white': selectedRole != '' && selectedRole.id != role.id
                }">
                <i class="fa fa-user-circle fa-3x"></i>
            </div>
            <div class="flex-1 p-2 flex flex-col justify-around text-left">
                <div>
                    <p class="text-sm flex"
                        :class="{
                            'text-brand font-medium': selectedRole.id == role.id, 
                            'text-black': selectedRole == '', 
                            'text-grey': selectedRole != '' && selectedRole.id != role.id
                        }">
                        {{ sanitize(role) }}
                    </p>
                    <p class="text-xs text-grey">
                        Assigned Tags: 
                        <span class="text-brand font-semibold"
                            :class="{
                                'text-grey-dark': selectedRole.id == role.id, 
                            }">
                            {{count}}
                        </span>
                    </p>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["role", "selected-role"],

  data() {
    return {
      count: 0,
      selected: false,
      open_info: false,
      descriptions: {
        userA: [
          "Super User - Administrator",
          "Access to $$ Trust Account to pay for Vault",
          "Opt users in and out of Vault",
          "Can - archive, upload, download, view, reinstate archives"
        ],
        userB: ["Opt users in and out of Vault", "Upload information", "Download information", "Can archive and reinstate archives"],
        userC: [
          "View all information and users",
          "Upload information",
          "Download information",
          "Can view archives",
          "Can only opt in Users E & F",
          "Voting process to change User A"
        ],
        userD: ["View all information", "Download information"],
        userE: ["User A or User B gives timed access to view selected information/ files"],
        userF: ["Limited time access", "Set by User A or User B", "View all information and download"],
        userG: ["Limited time access", "Set by User A or User B", "View all information and download"]
      },

      custom_header: {
        title: ["User A"]
      }
    };
  },

  mounted() {
    this.getMyTagsCount();
  },

  methods: {
    getMyTagsCount() {
      return axios.get(`api/vaults/${this.$route.params.vault_id}/roles/${this.role.id}/tags`).then(({ data }) => {
        this.count = data.length;
      });
    },

    selectRole() {
      if (this.selected) {
        this.selected = false;
        this.$emit("role-deselected");
      } else {
        this.selected = true;
        this.$emit("role-selected", {
          role: this.role
        });
      }
    },

    showInfo() {
      this.open_info = !this.open_info;
    },

    sanitize(role) {
      if (window.vault_type == "strata") {
        return role.title;
      }

      if (window.vault_type == "business") {
        let vault_id = this.current_vault.id;
        let role_name = role.name;
        let replace_char = vault_id + "-";
        let Role = role_name.replace(replace_char, " ");

        let index = _.findIndex(this.custom_header.title, t => {
          return _.trim(t) == _.trim(Role);
        });

        if (index == -1) {
          return Role;
        } else {
          return role.title.replace(/.+?(\- )/g, "");
        }
      }
    }
  },

  computed: {
    get_role_descriptions() {
      if (!_.isEmpty(this.role)) {
        let vault_id = this.$store.getters.getCurrentVault.id;
        let role_name = this.role.name;
        let replace_char = vault_id + "-";
        let role = _.camelCase(role_name.replace(replace_char, ""));

        return this.descriptions[role];
      }
    },
    ...mapGetters({
      current_vault: "getCurrentVault"
    })
  },

  watch: {
    selectedRole() {
      if (this.selectedRole != "") {
        if (this.selectedRole.id != this.role.id) {
          this.selected = false;
        } else {
          this.selected = true;
        }
      }
    }
  }
};
</script>

<style>
.tooltip.popover .popover-inner {
  background: #fff;
  border: 1px solid #01c2e3;
  color: #3d4852;
  padding: 16px;
}
.tooltip.popover .popover-arrow {
  border-color: #dae1e7;
}
</style>
